module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("动态管理 / 新增")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "label-width": "96px",
      "label-position": "left",
      "model": _vm.paramData,
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发布账号",
      "prop": "publishUid"
    }
  }, [_c('div', {
    staticClass: "form-item-row"
  }, [_c('div', {
    staticClass: "form-item-row__col form-item-row__col--author"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": _vm.onPublishAuthorTypeChange
    },
    model: {
      value: (_vm.paramData.publishAuthorType),
      callback: function($$v) {
        _vm.$set(_vm.paramData, "publishAuthorType", $$v)
      },
      expression: "paramData.publishAuthorType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "马甲号",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "官号",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "校园主理人",
      "value": 4
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-row__col form-item-row__col--mode"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": _vm.onAccountSearchModeChange
    },
    model: {
      value: (_vm.accountSearchMode),
      callback: function($$v) {
        _vm.accountSearchMode = $$v
      },
      expression: "accountSearchMode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "昵称",
      "value": "name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "用户ID",
      "value": "uid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-row__col form-item-row__col--grow"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "remote": "",
      "placeholder": "选择用户ID或昵称",
      "loading": _vm.selectLoading,
      "remote-method": _vm.queryBurnerAccount
    },
    on: {
      "change": _vm.onPublishUserChange,
      "clear": _vm.onAccountSelectClear
    },
    model: {
      value: (_vm.paramData.publishUid),
      callback: function($$v) {
        _vm.$set(_vm.paramData, "publishUid", $$v)
      },
      expression: "paramData.publishUid"
    }
  }, _vm._l((_vm.accountOptions), function(item) {
    return _c('el-option', {
      key: item.uid,
      attrs: {
        "label": item.nickName,
        "value": item.uid
      }
    }, [_c('div', {
      staticClass: "account-option"
    }, [(item.headImgUrl) ? _c('img', {
      staticClass: "account-option-avatar",
      attrs: {
        "src": item.headImgUrl,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName) + "（ID: " + _vm._s(item.uid) + "）")])])])
  }), 1)], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "话题"
    }
  }, [_c('div', {
    staticClass: "form-item-row"
  }, [_c('div', {
    staticClass: "form-item-row__col form-item-row__col--half"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "话题分类"
    },
    on: {
      "change": _vm.changeTopicCategory
    },
    model: {
      value: (_vm.paramData.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.paramData, "categoryId", $$v)
      },
      expression: "paramData.categoryId"
    }
  }, _vm._l((_vm.topicCategories), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-row__col form-item-row__col--half"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择话题（选填）",
      "disabled": !_vm.paramData.categoryId
    },
    model: {
      value: (_vm.paramData.topicIds),
      callback: function($$v) {
        _vm.$set(_vm.paramData, "topicIds", $$v)
      },
      expression: "paramData.topicIds"
    }
  }, _vm._l((_vm.topicList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "动态内容",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": 500,
      "placeholder": "请输入内容",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.paramData.content),
      callback: function($$v) {
        _vm.$set(_vm.paramData, "content", $$v)
      },
      expression: "paramData.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "素材"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择素材类型（选填）",
      "clearable": ""
    },
    on: {
      "change": _vm.onMaterialTypeChange
    },
    model: {
      value: (_vm.paramData.type),
      callback: function($$v) {
        _vm.$set(_vm.paramData, "type", $$v)
      },
      expression: "paramData.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "图片",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "视频",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), (_vm.paramData.type === 1) ? _c('el-form-item', {
    attrs: {
      "prop": "fids"
    }
  }, [_c('div', {
    staticClass: "flex-row image-list"
  }, [_c('SUpload', {
    attrs: {
      "limit": 9,
      "actionUrl": "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=6&fileType=1",
      "headers": _vm.uploadAuthHeaders,
      "accept": "image/*",
      "type": "drag",
      "show-file-list": false
    },
    model: {
      value: (_vm.paramData.fids),
      callback: function($$v) {
        _vm.$set(_vm.paramData, "fids", $$v)
      },
      expression: "paramData.fids"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.paramData.type === 2) ? _c('el-form-item', {
    attrs: {
      "prop": "fids"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.videoProcessing),
      expression: "videoProcessing"
    }],
    staticClass: "video-material-wrap",
    attrs: {
      "element-loading-text": "正在上传视频、生成封面并读取时长…"
    }
  }, [_c('UploadItem', {
    attrs: {
      "uploadImageType": "6",
      "fileType": "3",
      "keys": ("" + (_vm.paramData.fids[0].fid)),
      "accept": ".mp4",
      "max-video-duration-sec": 30,
      "max-video-size-mb": 50,
      "video-limit-toast": "视频最长30秒，最大50MB",
      "urls": _vm.paramData.fids[0].url
    },
    on: {
      "onUrls": _vm.videoUploaded,
      "upload-state": _vm.onVideoUploadState
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-limit-tip"
  }, [_vm._v("视频最长30秒，最大50MB")]), _vm._v(" "), (_vm.videoMetaHint) ? _c('div', {
    staticClass: "video-meta-hint"
  }, [_vm._v("\n            " + _vm._s(_vm.videoMetaHint) + "\n          ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发送时间"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.sendMode),
      callback: function($$v) {
        _vm.sendMode = $$v
      },
      expression: "sendMode"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "now"
    }
  }, [_vm._v("立即发送")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "scheduled"
    }
  }, [_vm._v("定时发送")])], 1), _vm._v(" "), (_vm.sendMode === 'scheduled') ? _c('el-date-picker', {
    staticStyle: {
      "margin-left": "12px",
      "width": "220px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择发送时间"
    },
    model: {
      value: (_vm.timedPublishAt),
      callback: function($$v) {
        _vm.timedPublishAt = $$v
      },
      expression: "timedPublishAt"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-20 save-actions"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isSaveDisabled
    },
    on: {
      "click": _vm.clickSave
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ee598ed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/Dynamics/DynamicManage/DynamicDetail.vue
// module id = 1065
// module chunks = 0